/**
 * @file
 *   Build a query string.
 */

/**
 * Get the page URL.
 *
 * @param int pageNum
 *   The human page number.
 * @param object model
 *   The data model.
 * @param query model
 *   The query string data.
 *
 * @return string
 *   The pagination URL.
 */
export function getPageUrl(pageNum, model, state) {
  var facets = getPageFacets(state);
  var keyword = getKeyword(state);
  var page = getPageIndex(pageNum);
  var queryString = '';
  var sortBy = getSortBy(state);

  queryString += facets ? facets : '';
  queryString += (queryString && keyword) ? '&' + keyword : keyword;
  queryString += (queryString && sortBy) ? '&' + sortBy : sortBy;
  queryString += (queryString && page) ? '&' + page : page;

  return '?' + queryString + '#' + getAnchorId(model);
}

/**
 * Determine if this is a page load or an in-page load.
 *
 * @return int
 *   The load in-page flag.
 */
export function loadInPage() {
  return 0;
}

/**
 * Get the anchor ID.
 *
 * @param object state
 *   The query string model.
 *
 * @return string
 *   The anchor ID.
 */
function getAnchorId(model) {
  return model.id ? model.id : 'search-0';
}

/**
 * Get the keyword field.
 *
 * @param object state
 *   The query string model.
 *
 * @return string
 *   The URL encoded search string.
 */
function getKeyword(state) {
  return state.keyword ? 'keyword=' + encodeURIComponent(state.keyword) : '';
}

/**
 * Get the page index.
 *
 * @param object state
 *   The query string model.
 *
 * @return string
 *   The facets query string.
 */
function getPageFacets(state) {
  var facets = '';

  if (!state.f || !state.f.length) {
    return '';
  }
  for (var i = 0; i < state.f.length; i++) {
    facets += facets ? '&f[' + i + ']=' + encodeURIComponent(state.f[i]) : 'f[' + i + ']=' + encodeURIComponent(state.f[i])
  }
  return facets;
}

/**
 * Get the page index.
 *
 * @param int page
 *   The human page number.
 *
 * @return string
 *   The page query string.
 */
function getPageIndex(page) {
  return (page > 1) ? 'page=' +  (page - 1) : 'page=0';
}

/**
 * Get the sorting field.
 *
 * @param object state
 *   The query string model.
 *
 * @return string
 *   The name of the sorting field.
 */
function getSortBy(state) {
  return state.sort_by ? 'sort_by=' + state.sort_by : '';
};
